import { render, staticRenderFns } from "./RecordStatus.vue?vue&type=template&id=2e678092&"
import script from "./RecordStatus.vue?vue&type=script&lang=js&"
export * from "./RecordStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports